import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const usePageViews = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search
      });
    }
  }, [location.pathname, location.search]);
};
